// Mock data for Football X application

export const mockRegistrationSubmit = (formData) => {
  console.log('Mock registration submitted:', formData);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: `Registration received for ${formData.playerName}. We'll contact you at ${formData.email} soon!`
      });
    }, 1000);
  });
};

export const mockEOISubmit = () => {
  console.log('Mock EOI submitted - redirecting to external form');
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        redirect: 'https://forms.gle/Ts8w3RXV4wuKuHMU6'
      });
    }, 500);
  });
};

export const mockSocialMediaFeeds = {
  facebook: {
    posts: [
      {
        id: 1,
        content: "Great training session today with our Under 15s! The dedication and improvement shown by these young athletes is incredible. #FootballX #YouthDevelopment",
        date: "2 days ago",
        likes: 45,
        comments: 8
      },
      {
        id: 2,
        content: "Congratulations to our Football X FC team for their outstanding performance in this weekend's Sydney Premier League match! 🏆",
        date: "5 days ago",
        likes: 78,
        comments: 15
      }
    ]
  },
  instagram: {
    posts: [
      {
        id: 1,
        image: "https://customer-assets.emergentagent.com/job_72705d3c-2808-40ba-a037-13ac33d3cb8e/artifacts/cuhw8w09_IMG_0750.jpg",
        caption: "Training hard, dreaming big! 💪⚽ #FootballXAcademy #YouthFootball",
        likes: 156,
        date: "1 day ago"
      },
      {
        id: 2,
        image: "https://customer-assets.emergentagent.com/job_72705d3c-2808-40ba-a037-13ac33d3cb8e/artifacts/54bmglqg_IMG_0751.jpg",
        caption: "Academy session focus: First touch and ball control drills ⚽✨ #TechnicalSkills #FootballX",
        likes: 203,
        date: "3 days ago"
      }
    ]
  },
  youtube: {
    videos: [
      {
        id: 1,
        title: "Football X Podcast Episode 15: Youth Development in Modern Football",
        thumbnail: "https://customer-assets.emergentagent.com/job_72705d3c-2808-40ba-a037-13ac33d3cb8e/artifacts/ktyowyc6_IMG_0752.jpg",
        duration: "45:30",
        views: "2.1K",
        date: "1 week ago"
      },
      {
        id: 2,
        title: "Training Highlights: Football X Academy Skills Session",
        thumbnail: "https://customer-assets.emergentagent.com/job_72705d3c-2808-40ba-a037-13ac33d3cb8e/artifacts/54bmglqg_IMG_0751.jpg",
        duration: "12:45",
        views: "1.8K",
        date: "2 weeks ago"
      }
    ]
  }
};

export const mockCoachingStaff = [
  {
    name: "Michael Thompson",
    qualification: "AFC A License",
    role: "Head Coach - Football X FC",
    experience: "8 years coaching experience",
    specialization: "Tactical Development & Match Strategy"
  },
  {
    name: "Sarah Johnson",
    qualification: "AFC B License",
    role: "Academy Director",
    experience: "6 years youth development",
    specialization: "Technical Skills & Individual Development"
  },
  {
    name: "David Rodriguez",
    qualification: "Strength & Conditioning Certified",
    role: "Fitness Coach",
    experience: "5 years sports science",
    specialization: "Physical Development & Injury Prevention"
  }
];